import React from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BLOG_POSTS } from '../data/blog';
import { setMeta } from '../lib/seo';
import Footer from '../components/Footer';

export default function BlogIndex() {
  useEffect(() => {
    setMeta({
      title: 'The Culinera Food Journal — Alberta Restaurants, Hidden Gems & Culinary Road Trips',
      description: 'Thirteen original Alberta food articles: Calgary 17th Avenue walking guides, the 5-day Calgary to Jasper road trip, the Cowboy Trail, Indigenous cuisine, Edmonton food trucks, seasonal eating, the Bow Valley, and more.',
      canonical: 'https://culinera.ca/blog',
    });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center py-4">
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-full flex items-center justify-center">
              <span className="text-white font-bold text-sm">C</span>
            </div>
            <span className="text-xl font-bold text-gray-900">Culinera</span>
          </Link>
          <Link to="/" className="text-teal-600 hover:text-teal-700 font-semibold">← Home</Link>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-10">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-3">The Culinera Food Journal</h1>
          <p className="text-lg text-gray-600 max-w-3xl">Hand-written field notes from Alberta&rsquo;s culinary landscape — restaurant deep-dives, road-trip guides, hidden-gem profiles, and seasonal eating tips. No AI fluff, no SEO filler.</p>
        </div>

        <ul className="grid md:grid-cols-2 gap-6">
          {BLOG_POSTS.map((post) => (
            <li key={post.slug} data-testid={`blog-card-${post.slug}`}>
              <Link to={`/blog/${post.slug}`} className="block bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow h-full overflow-hidden">
                {post.heroImageUrl && (
                  <div className="h-40 overflow-hidden">
                    <img src={post.heroImageUrl} alt={post.heroAlt || post.title} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                )}
                <div className="p-6">
                <div className="flex items-center gap-2 text-xs mb-2">
                  <span className="bg-teal-100 text-teal-800 px-2 py-1 rounded font-semibold">{post.category}</span>
                  <span className="text-gray-500">{post.readMinutes} min read</span>
                  <span className="text-gray-400">·</span>
                  <span className="text-gray-500">{post.publishedAt}</span>
                </div>
                <h2 className="text-xl font-bold text-gray-900 mb-2 leading-snug">{post.title}</h2>
                <p className="text-sm text-gray-700">{post.excerpt}</p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </main>
      <Footer />
    </div>
  );
}
